import { FileX } from 'lucide-react';
import { Text } from '../design-system/Text';

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500">
        <FileX className="h-8 w-8" />
      </div>
      <Text variant="title" className="mt-4">No challans found</Text>
      <Text variant="body" color="secondary" className="mt-1">
        Great news — there are no pending challans for this vehicle.
      </Text>
    </div>
  );
}
